import { assignArray } from "../assignArray";
import { isSet } from "../typeMatchers";

/**
 * Assign members of second array to first
 */
export function assignSet(target: Set<any>, source: Iterable<any>): void {
	if (isSet(source) || Array.isArray(source)) {
		const array = Array.from(target);
		assignArray(array, Array.from(source));

		target.clear();
		array.forEach((item) => target.add(item));
	}
}
